import { trackSegmentEvent } from '~/components/shared/tracking/segmentAnalytics';

export function initializePriceSearchForm() {
  let form;
  document
    .querySelectorAll('[data-price-search-controller]')
    .forEach((controller) => {
      form = controller.querySelector('[data-price-search-form]');
      const cards = controller.querySelectorAll('[data-price-search-card]');

      controller.querySelectorAll('[data-price-search-reset]').forEach((el) => {
        el.addEventListener('click', () => {
          form.reset();
          delete form.dataset.submitted;
          setCardActive('search');
        });
      });

      function setCardActive(cardName) {
        cards.forEach((card) => {
          if (card.dataset.priceSearchCard === cardName) {
            card.classList.remove('hidden');
          } else {
            card.classList.add('hidden');
          }
        });
      }

      function updateResultsCardContent(data) {
        const resultsCard = Array.from(cards).find(
          (c) => c.dataset.priceSearchCard === 'results',
        );
        delete data['no_results'];
        for (const key of Object.keys(data)) {
          const el = resultsCard.querySelector(`[data-${key}]`);
          if (key === 'link') {
            el.href = data[key];
          } else {
            el.textContent = data[key];
          }
        }
      }

      function resultSegmentEvent(formData, success = true) {
        const event = 'Content - CTA';
        const properties = {
          action: 'click',
          cta_type: 'button',
          cta_topic: 'local pricing',
          zip_code: formData.get('zip_code'),
          result: success ? 'success' : 'no data',
          ...getContextProperties(),
        };
        trackSegmentEvent(event, properties);
      }

      function formListener(e) {
        e.preventDefault();
        form.dataset.submitted = true;

        setCardActive('loading');

        const formData = new FormData(form);
        fetch('/clearprice', {
          body: formData,
          method: 'POST',
        })
          .then((res) => {
            if (res.status === 200) {
              return res.json();
            } else {
              return {
                error: true,
              };
            }
          })
          .then((data) => {
            if (data.no_results || data.error) {
              setCardActive('no-results');
              resultSegmentEvent(formData, false);
            } else {
              // set results card active
              updateResultsCardContent(data);
              setCardActive('results');
              resultSegmentEvent(formData);
            }
          });
      }

      form.addEventListener('submit', formListener);
    });
  return form;
}
